var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mr-4",attrs:{"to":"simulations/add","dark":"","color":"primary"}},[_c('v-icon',[_vm._v("add")]),_vm._v("新規登録\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }